import { getField, updateField } from 'vuex-map-fields'
import getAssignmentFiltersModel from './models/assignmentFilters'

const assignmentFilters = {
  namespaced: true,
  state: {
    ...getAssignmentFiltersModel()
  },
  getters: {
    getField,
    getSearchObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    // Reset from the model, like placementFilters, rather than field by field: the hand-written
    // version had already drifted and left employeeTypeId applied after a Clear.
    clearFilters: (state) => {
      Object.assign(state, getAssignmentFiltersModel())
    }
  },
  actions: {
    clearFilters: ({ commit }) => {
      return commit('clearFilters')
    }
  }
}

export default assignmentFilters
